import type { ComponentType, ReactNode, SVGProps } from 'react';

type LucideIcon = ComponentType<SVGProps<SVGSVGElement>>;

interface FeatureCardProps {
  icon?: LucideIcon;
  title: string;
  description: ReactNode;
  className?: string;
}

export function FeatureCard({ icon: Icon, title, description, className }: FeatureCardProps) {
  return (
    <article
      className={[
        'flex flex-col gap-3 rounded-xl border border-border bg-card p-6 shadow-soft transition-[colors,box-shadow] duration-fast ease-out-quart hover:border-brand/40 hover:shadow-glow',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {Icon ? (
        <span
          aria-hidden="true"
          className="inline-flex h-10 w-10 items-center justify-center rounded-md bg-primary-soft text-brand"
        >
          <Icon className="h-5 w-5" />
        </span>
      ) : null}
      <h3 className="text-lg font-semibold text-foreground">{title}</h3>
      <p className="text-sm text-muted-foreground">{description}</p>
    </article>
  );
}
